import { supabase } from '@/integrations/supabase/client';
import type {
  MetricsHistoryEntry,
  PerformanceMetrics,
} from '../types/content.types';
import { apifyMetricsScraper } from '../infrastructure/apifyMetricsScraper';
import type { ScrapeMetricsResponse } from '../ports/contentScraper.port';

export class ContentMetricsRepository {
  /**
   * Trigger scraping for a post submission using the decoupled scraper port.
   */
  async triggerPostScrape(submissionId: string): Promise<ScrapeMetricsResponse> {
    return apifyMetricsScraper.scrapePostMetrics(submissionId);
  }

  /**
   * Fetch snapshot history for a post submission.
   */
  async getMetricsHistory(
    orgId: string,
    submissionId: string
  ): Promise<MetricsHistoryEntry[]> {
    if (!submissionId) return [];

    await supabase.rpc('set_current_organization', { org_id: orgId });

    const { data, error } = await supabase
      .from('content_submission_metrics_history' as 'campaign_audit_log')
      .select('*')
      .eq('content_submission_id' as 'campaign_id', submissionId)
      .order('snapshot_at' as 'changed_at', { ascending: false });

    if (error) {
      console.warn('Metrics history fetch error:', error);
      return [];
    }

    return (data || []).map((row: any) => ({
      id: row.id,
      content_submission_id: row.content_submission_id,
      performance_metrics: row.performance_metrics as PerformanceMetrics,
      snapshot_at: row.snapshot_at,
      extraction_source: row.extraction_source || 'manual',
      extracted_by: row.extracted_by,
      notes: row.notes,
      created_at: row.created_at,
    }));
  }
}

export const contentMetricsRepository = new ContentMetricsRepository();
